/*export const parseShortTextProjects = (shortText: string) => {
    return shortText.split(', ').map(pair => {
        const [key, value] = pair.split(': ');
        return { title: key.trim(), description: value.trim() };
    });
};*/

export const parseShortTextProjects = (shortText: string) => {
    return shortText.split('; ').map(pair => {
        const colonIndex = pair.indexOf(': '); // Ищем первое двоеточие с пробелом
        if (colonIndex === -1) {
            console.warn('Skipping invalid pair:', pair);
            return { title: 'Unknown', description: pair.trim() };
        }
        const key = pair.substring(0, colonIndex).trim();
        const value = pair.substring(colonIndex + 2).trim();
        return { title: key, description: value };
    });
};
